import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { axiosDeleteData, axiosGetData, axiosPostData, axiosPutData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { ExchangeRateRefDateMappingRepository } from "./ExchangeRateRefDateMappingRepo";
import { ExchangeRateRefDateMappingEntity } from "domain/entity/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingEntity";
/** 
 * For template 
 * @returns  
 */ 
export const ExchangeRateRefDateMappingRepoImpl = (): ExchangeRateRefDateMappingRepository => { 
    const url = '/v1/exchangeRateRefDateMapping'; 
    const getEntities = async() : Promise<ExchangeRateRefDateMappingEntity[]> => { 
        return await axiosGetData(referenceAxiosInstance, url, []).then(res => { 
            return res.data 
        }).catch(err => { 
            return []; 
        }); 

    } 
    const getEntityByKey = async(key: string): Promise<ExchangeRateRefDateMappingEntity> => { 
        return await axiosGetData(referenceAxiosInstance, `${url}/${key}`, []).then(res => { 
            return res.data; 
        }).catch(err => { 
            return null; 
        }); 
    } 
    const createEntity = async(newData: ExchangeRateRefDateMappingEntity) : Promise<ResponseEntity> => { 
        return await axiosPostData(referenceAxiosInstance, `${url}`, newData); 
    } 
    const updateEntity = async(updatedData: ExchangeRateRefDateMappingEntity): Promise<ResponseEntity> => { 
        return await axiosPutData(referenceAxiosInstance, `${url}`, updatedData); 
    } 
    const deleteEntity= async(key: string): Promise<ResponseEntity> => { 
        return await axiosDeleteData(referenceAxiosInstance, `${url}`, key); 
    } 
    return { 
        getEntities: getEntities, 
        getEntityByKey: getEntityByKey, 
        createEntity: createEntity, 
        updateEntity: updateEntity, 
        deleteEntity: deleteEntity, 
    }
} 
